import React from 'react';

import { Link } from 'react-router-dom';

import { Button } from '@shared/components/ui';


const CTASection: React.FC = () => {
  return (
    <section className="px-4 py-16 sm:px-6 sm:py-24 lg:px-8">
      <div className="mx-auto max-w-2xl text-center">
        <h2 className="text-foreground text-3xl font-light sm:text-4xl">
          Ready to <strong className="font-semibold">Get Started</strong>?
        </h2>
        {/* Honest about the gate: an unknown Google account lands on /waitlist,
            not in the app. Promising an account here would be a bait-and-switch. */}
        <p className="text-muted-foreground mt-4 text-lg">
          Conway is invite-only while it is still being built. Sign in with Google to claim a spot
          on the waitlist — or to get straight in, if you already have one.
        </p>
        <div className="mt-8">
          <Link to="/signin">
            <Button variant="primary" size="lg">
              Continue with Google
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
